/**
 * Setup Sentry.io error reporting
 */
import * as Sentry from '@sentry/browser';

if (gwbSrv && gwbSrv.sentry && gwbSrv.sentry.enabled) {
    Sentry.init({
        dsn: gwbSrv.sentry.dsn,
        environment: gwbSrv.env,
        release: gwbSrv.version,
    });

    Sentry.configureScope((scope) => {
        scope.setTag('section', 'outerweb');
        if (gwbSrv.user) {
            scope.setUser({
                id: gwbSrv.user.id
            })
        }
    });
}

